import { IComputedAggregate } from '../data/types';

/**
 * makes sure the aggregate has data and is not an empty document
 *
 * @param a {Object}
 *
 * @returns {Boolean}
 */
const validAggregate = (aggregrate: IComputedAggregate): boolean => {
  const keys = Object.keys(aggregrate?.data ?? {});
  return keys.length > 1 && hasCountGreaterThan0(aggregrate?.data, keys);
};

/**
 * makes sure at least one property in the object has a count property that is > 0
 *
 * @param obj {Object}
 * @param keys {Array}
 *
 * @returns {Boolean}
 */
const hasCountGreaterThan0 = (obj, keys) => {
  return keys.reduce((acc, curr) => {
    if (acc) return acc;
    return obj[curr] && obj[curr].count && obj[curr].count > 0;
  }, false);
};
export { validAggregate };
